export default "__VITE_ASSET__028ebb03__"